import { Pill } from '@mantine/core';

/**
 * A pill that ellipsises instead of stretching its column — the full
 * value stays readable on hover. The table-cell pill for free-text
 * list values (subjects, jurisdictions); in fixed-layout tables the
 * cell width is the cap.
 */
export function TruncatingPill({ label }: Readonly<{ label: string }>) {
  return (
    <Pill
      size="sm"
      maw="100%"
      title={label}
      styles={{ label: { overflow: 'hidden', textOverflow: 'ellipsis' } }}
    >
      {label}
    </Pill>
  );
}
